module.exports = __webpack_public_path__ + "./Sherry_0253f631bc3237551b6aee96b76f9ae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Sherry.jpg
// module id = 506
// module chunks = 0